// src/lib/userConnectionAuth.js
// Per-user import stats (last import, counts) for the Connect & Import dialog.
// Connections themselves live server-side; see lib/integrations.js.

import { saveUserData, loadUserData, STORAGE_KEYS } from './userStorage';

// Gets current connection status for all services for a user
export function getConnectionStatus(userId) {
  if (!userId) {
    return {
      jira: { connected: false, lastImport: null, issueCount: 0 },
      slack: { connected: false, lastImport: null, alertCount: 0 }
    };
  }

  const defaultStatus = {
    jira: { connected: false, lastImport: null, issueCount: 0 },
    slack: { connected: false, lastImport: null, alertCount: 0 }
  };

  return loadUserData(userId, STORAGE_KEYS.CONNECTIONS, defaultStatus);
}

// Updates connection status for a user
export function updateConnectionStatus(service, status, userId) {
  if (!userId) return {};

  const connections = getConnectionStatus(userId);
  connections[service] = { ...connections[service], ...status };
  saveUserData(userId, STORAGE_KEYS.CONNECTIONS, connections);
  return connections;
}
